import React from 'react';
import HBMediaElement, {
    IMediaElementProps
} from '../../HBMediaElement/HBMediaElement';
import { isLottieAnimation } from '../../HBBanner/utils';
import LottiePlayer from 'lottie-react';
import styled, { css } from 'styled-components';
import { CalloutLayout } from './Callout.types';
import HBClickable from '../../HBClickable/HBClickable';
import { ImageFit } from '../../../tokens/types';
import { PaginationModeProps } from '../../HBCalloutCard/HBCalloutCard.types';

interface Props
    extends Pick<IMediaElementProps, 'autoPlay' | 'muted' | 'controls'> {
    mediaPath: string | object;
    imageFit: ImageFit;
    layout: CalloutLayout;
    withImagePadding: boolean;
    width: number | string;
    onClick?: () => void;
    currentStep?: number;
    steps?: PaginationModeProps['steps'];
}

function CalloutMediaElement({
    mediaPath,
    imageFit,
    layout,
    onClick,
    withImagePadding,
    width: _width,
    currentStep,
    steps,
    ...props
}: Props) {
    const width = layout === 'side-by-side' ? _width : '100%';

    let _mediaPath: typeof mediaPath;
    let _onClick: typeof onClick;
    if (steps) {
        _mediaPath = steps[currentStep].mediaPath;
        _onClick = steps[currentStep].onImageClick;
    } else {
        _mediaPath = mediaPath;
        _onClick = onClick;
    }

    return (
        <Container
            $objectFit={imageFit}
            $layout={layout}
            $withPadding={withImagePadding}
            onClick={_onClick}
        >
            {isLottieAnimation(_mediaPath) ? (
                <StyledLottiePlayer animationData={_mediaPath} $width={width} />
            ) : (
                <HBMediaElement path={_mediaPath} width={width} {...props} />
            )}
        </Container>
    );
}

export default CalloutMediaElement;

// -------------------------- Styles -------------------------- //

export const Container = styled(HBClickable)<{
    $withPadding: boolean;
    $objectFit: 'cover' | 'contain';
    $layout: 'default' | 'center' | 'side-by-side';
}>(
    ({ $layout, $withPadding, $objectFit }) => css`
        display: flex;

        ${$withPadding &&
        css`
            padding: 32px 32px
                ${$layout === 'side-by-side' ? '32px 0' : '0 32px'};
        `}

        * {
            display: flex;
            flex: 1;
            object-fit: ${$objectFit};
            max-width: 100%;
            height: 100%;
        }
    `
);

export const StyledLottiePlayer = styled(LottiePlayer)<{
    $width: number | string;
}>`
    width: ${({ $width }) =>
        typeof $width === 'string' ? $width : `${$width}px`};
    height: auto !important;
    align-self: center;
`;
